import { Link } from 'react-router-dom';
import { useDealerAuth } from '../context/DealerAuthContext';
import { useTheme } from '@/context/ThemeContext';

interface Props {
  title: string;
}

export default function DealerTopbar({ title }: Props) {
  const { dealer } = useDealerAuth();
  const { theme, toggleTheme } = useTheme();
  const dark = theme === 'dark';

  return (
    <header className={`h-16 flex items-center justify-between px-6 border-b shrink-0 ${dark ? 'bg-[#0D1B2A] border-white/10' : 'bg-white border-gray-200'}`}>
      <div className="flex items-center gap-3">
        <img
          src="https://static.readdy.ai/image/3bab8804b943b0f9d2e99ce4e4e8123d/a7b2a29c0c21ce8564d3744200077816.png"
          alt="Stingray"
          className={`md:hidden h-6 w-auto object-contain brightness-0 ${dark ? 'invert' : ''}`}
        />
        <h1 className={`font-bold text-base ${dark ? 'text-white' : 'text-gray-900'}`}>{title}</h1>
      </div>

      <div className="flex items-center gap-3">
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap border ${
            dark
              ? 'bg-white/10 border-white/20 text-white hover:bg-white/20'
              : 'bg-gray-100 border-gray-200 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className={dark ? 'ri-sun-line' : 'ri-moon-line'}></i>
          </div>
          {dark ? 'Light' : 'Dark'}
        </button>

        <Link
          to="/dealer/new-order"
          className="flex items-center gap-2 text-white text-xs font-bold px-4 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          style={{ backgroundColor: 'var(--accent)' }}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-add-line"></i>
          </div>
          New Order
        </Link>

        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          className={`flex items-center gap-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${dark ? 'text-white/40 hover:text-white' : 'text-gray-400 hover:text-gray-700'}`}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-external-link-line"></i>
          </div>
          View Site
        </a>

        <div className="w-8 h-8 flex items-center justify-center rounded-full text-white text-xs font-black cursor-pointer shrink-0" style={{ backgroundColor: 'var(--accent)' }}>
          {dealer?.contact?.charAt(0) ?? 'D'}
        </div>
      </div>
    </header>
  );
}
